export default __webpack_public_path__ + "static/media/warning-sign.43965234.svg";